// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import App from './App'
import router from './router'
import ElementUI from 'element-ui'
import 'element-ui/lib/theme-chalk/index.css'
import './assets/icon/iconfont.css'
import Fragment from 'vue-fragment'
import fn from './page/util/fn'
import md5 from 'js-md5'
import VueRouter from 'vue-router'
import './assets/elmenticon/iconfont.css'
import adaptive from './directive'
import Cookies from 'js-cookie'
import CcFormDisplayModify from './components/globalComponents/CcFormDisplayModify.vue'

import Ea from 'e-admin'

Vue.use(ElementUI).use(Ea)
Vue.use(adaptive)
Vue.use(fn)
Vue.use(Cookies)
Vue.use(VueRouter)
Vue.prototype.$md5 = md5
Vue.use(Fragment.Plugin)
Vue.config.productionTip = false
Vue.component('cc-form', CcFormDisplayModify)

Vue.use(ElementUI)
// 防止连点
// 使用方法,在需要防止连点的元素 配置v-points,自定义间隔时长1秒: v-points="1000"
// 代码
const pointDoms = [] // 使用这个指令的所有DOM对象
Vue.directive('points', {
  inserted (el, binding) {
    pointDoms.push(el) // 存储使用这个指令的DOM
    el.addEventListener('click', () => {
      // 禁用所有使用这个指令的DOM结构点击事件
      pointDoms.forEach(pointItem => {
        pointItem.style.pointerEvents = 'none'
      })
      setTimeout(() => {
        // 启动所有使用这个指令的DOM结构点击事件
        pointDoms.forEach(pointItem => {
          pointItem.style.pointerEvents = 'auto'
        })
      }, binding.value || 350)
    })
  }
})

/* eslint-disable no-new */
new Vue({
  el: '#app',
  router,
  render: h => h(App),
  beforeCreate () {
    Vue.prototype.$bus = this // 安装全局事件总线
  }
})



// WEBPACK FOOTER //
// ./src/main.js